"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coalesceEmptyArray = exports.isFunctionDefined = exports.isEmptyObject = void 0;
const isEmptyObject = obj => {
    return Object.keys(obj).length === 0;
};
exports.isEmptyObject = isEmptyObject;
const isFunctionDefined = (fn) => {
    return typeof fn === 'function';
};
exports.isFunctionDefined = isFunctionDefined;
const coalesceEmptyArray = (left, right) => (left.length > 0 ? left : right);
exports.coalesceEmptyArray = coalesceEmptyArray;
